import { ReactNode } from 'react'
import localFont from 'next/font/local'

import { BaseFontProvider } from './base-font-provider'

// Self-hosted (latin subset) instead of next/font/google so a cold `next build`
// has no build-time dependency on Google Fonts. Urbanist is a variable font:
// one woff2 covers the whole weight range. Re-vendor via
// scripts/vendor-google-fonts.mjs.
const urbanist = localFont({
  src: '../../public/fonts/urbanist/Urbanist-variable.woff2',
  weight: '400 600',
  display: 'fallback',
})

export const UrbanistProvider = ({ children }: { children: ReactNode }) => {
  return <BaseFontProvider font={urbanist}>{children}</BaseFontProvider>
}
